import { BaseModel } from './base.model'
import { User } from './user.model'

export class Odometer extends BaseModel {
  id: number
  accuracy: number
  deviceId: number
  createdAt: string
  createdBy: User
  driverId: number
  isSyncedWithDevice: boolean
  lastTrackerRecordOccurredAt: string
  prevOdometer: number
  lastTrackerRecordOdometer: number
  occurredAt: string
  odometer: number
  vehicleId: number

  constructor(src?: Odometer) {
    super(src)

    // converting meters to kilometers
    this.odometer = this.toKm(this.odometer)
    this.lastTrackerRecordOdometer = this.toKm(this.lastTrackerRecordOdometer)
    this.prevOdometer = this.toKm(this.prevOdometer)
  }

  toKm(meters: number): number {
    return Math.round(meters / 1000)
  }
}
